import { useCallback, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { MaterialReactTable } from 'material-react-table';
import type { PaginationState, ColumnFiltersState, SortingState } from '@tanstack/react-table';
import { MRT_Localization_AL, PAGES } from '../../../../constants/Constants'
import { handleSearchData, paginationQuery } from '../../../../utils/GlobalHelper'
import { useForm } from 'react-hook-form'
import ServiceManagementFilter from '../../../../components/Model/ServiceManagementFilter';
import { dateFormat, encodeID, handleShowSwalConfirmation, sidebarOpen } from '../../../../utils/Helper';
import { CategoryAction, ProfileGetCategoryAction } from '../../../../redux/Action/ProfileAction';
import _ from 'lodash';


import { StaffMemberAddAction, StaffMemberDeleteAction, StaffMemberListAction, StaffMemberStatusAction } from '../../../../redux/Action/StaffMemberAction';
import AddNewStaff from '../../../../components/Model/AddNewStaff';


import { FormattedMessage } from 'react-intl';
import { useIntl } from 'react-intl';



const StaffMember = () => {
    const intl = useIntl();

    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const staff_member = useSelector((state: any) => state.StaffMemberListState);
    const staff_member_delete = useSelector((state: any) => state.StaffMemberDeleteState);
    const staff_member_status = useSelector((state: any) => state.StaffMemberStatusState);
    const profile_data = useSelector((state: any) => state.GetProfileState);

    const [data, setData] = useState<any>();
    const [pagination, setPagination] = useState<PaginationState>({ pageIndex: PAGES?.pageIndex, pageSize: PAGES?.pageSize });
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([{ id: "category", value: 268 }]);
    const [sorting, setSorting] = useState<SortingState>([]);
    const [rowCount, setRowCount] = useState(0);
    const [searchValue, setSearchValue]: any = useState('');
    const [isError, setIsError] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disableDate, setDisableDate] = useState(true)

    const add_staff_member = useSelector((state: any) => state.StaffMemberAddState);


    useEffect(() => {
        const fetchData = async () => {
            if (!data?.length) {
                setLoading(true);
            }
            else {
                setIsRefetching(true);
            }
            try {
                let query: any = paginationQuery(pagination.pageIndex, pagination.pageSize, sorting, searchValue, columnFilters);
                const data = {
                    ...query,
                    parent_id: profile_data?.data?.data?.id
                }
                await dispatch(StaffMemberListAction(data));
            }
            catch (error) {
                setIsError(true);
                return;
            }
            setIsError(false);
            setLoading(false);
            setIsRefetching(false);
        };
        if (columnFilters || pagination.pageIndex || pagination.pageSize || sorting || staff_member_delete || staff_member_status) {
            fetchData();

        }
    }, [columnFilters, pagination.pageIndex, pagination.pageSize, sorting, staff_member_delete, staff_member_status, add_staff_member?.data]);
    // }, [columnFilters, pagination.pageIndex, pagination.pageSize, sorting, staff_member_delete, staff_member_status, add_staff_member?.status]);


    useEffect(() => {
        if (staff_member?.status) {
            setRowCount(staff_member?.data?.data?.count);
            setData(staff_member?.data?.data?.rows);
        }
    }, [staff_member?.data]);


    const handleStatus: any = (id: any, status: any) => {
        dispatch(StaffMemberStatusAction({ status_id: id, status: status }))
    }



    const columns: any = [
        {
            accessorKey: 'S.NO',
            header: <FormattedMessage id="sno" />,
            accessorFn: (row: Object, index: number) => {
                return index + 1;
            },
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
            size: 50,
        },
        {
            accessorKey: 'Staff Member name and email',
            header: <FormattedMessage id="staff_member_name" />,
            accessorFn: (row: any) => {
                return (
                    <>
                        <div className='useritmes'>
                            <figure><img src={row?.profile_pic ? row?.profile_pic : "images/fely-beauty.jpg"} onError={(e: any) => e.target.src = "images/fely-beauty.jpg"} /></figure>
                            <div className='userItmeINfo'>
                                <p><b>{row?.owner_name ? row?.owner_name : "N/A"}</b></p>
                                <p>#{row?.id ? row?.id : "N/A"}</p>
                            </div>
                        </div>
                    </>
                )
            },
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
            size: 50,

        },
        {
            accessorKey: 'Email & Phone Number',
            header: <FormattedMessage id="email_phone_number" />,
            accessorFn: (row: any) => {
                return (
                    <>
                        <td>{row?.email ? row?.email : "N/A"}<br /> {row?.phone_country_code ? `+${row?.phone_country_code.replace(/^\++/, '')}` + " " + row?.phone_number : "N/A"}</td>
                    </>
                )
            },
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
            size: 50,
        }, 
        {
            accessorKey: 'Creation Date',
            header: <FormattedMessage id="creation_date" />,
            accessorFn: (row: any) => {
                return (
                    <>
                        <td>{dateFormat(row?.created_at)}</td>
                    </>
                )
            },
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
            size: 50,

        },
        {
            accessorKey: 'status',
            header: <FormattedMessage id="status" />,
            size: 50,

            accessorFn: (row: { id: any, status: number }) => <>
                <div className="form-check form-switch" >
                    <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                        checked={row.status == 1 ? true : false}
                        onClick={() => handleStatus(row?.id, row?.status == 1 ? 0 : 1)}
                    />
                </div>
            </>,
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false,
        },
        {
            accessorKey: 'Action',
            header: <FormattedMessage id="action" />,
            size: 50,

            accessorFn: (row: { id: any, status: number }) => <>
                {/* <td> */}
                <div className='userAction'>
                    <Link to={`/staff-member/update/${encodeID(row?.id)}`} className='btn btnroundIcon'><i className="icon-edit"></i></Link>
                    <button type='button' className='btn btnroundIcon mx-1 mx-sm-2' onClick={() => handleDelete(row?.id)}><i className="icon-delete"></i></button>
                    <Link to={`/staff-member/view/${encodeID(row?.id)}`} className='btn btnroundIcon'><i className="icon-view"></i></Link>
                    {/* <Link to={`/staff-member/view/${encodeID(row?.id)}`} className='link'><i className="icon-view"></i>View</Link> */}
                </div>
            </>,
            enableSorting: false,
            enableColumnOrdering: false,
            enableColumnDragging: false,
            enableColumnFilter: false
        },
    ]

    const { register, handleSubmit, reset, setValue, watch, formState: { errors } } = useForm({
        defaultValues: { start_date: "", end_date: "", searchValue: "", category: "" }
    }) as any;


    const [searched, setSearched] = useState<string>("");


    const onSubmit = (payload: any) => {

        const columnFilters = [
            { id: "start_date", value: payload?.start_date },
            { id: "end_date", value: payload?.end_date },
            { id: "category_id", value: payload?.category },
        ]
        setColumnFilters(columnFilters)
    }




    const handleReset = () => {
        reset();
        setSearched("")
        setColumnFilters([])
    }



    const requestSearch = useCallback(
        _.debounce((searchedVal: string) => {
            if (searchedVal.length > 0) {
                setSearched(searchedVal);

                const filteredRows = data && data.filter((row: any) => {
                    return row?.name?.toLowerCase().includes(searchedVal.toLowerCase());
                });
                const columnFilters = [
                    { id: "start_date", value: "" },
                    { id: "end_date", value: "" },
                    { id: "search", value: searchedVal },
                ]

                const dataData = [{ id: "search", value: searchedVal }]
                setColumnFilters(dataData)

            } else {
                setColumnFilters([])
            }
        }, 1000),
        []
    );

    // const handleSearchChange = (searchVal: any) => {
    //     setSearched(searchVal?.target?.value)
    //     requestSearch(searchVal?.target?.value);
    // };

    const handleSearchChange = (searchVal: any) => {
        const value = searchVal?.target?.value.replace(/\s{2,}/g, ' ');

        setSearched(value)
        requestSearch(value.trim());
    };



    const handleFilter = () => {
        // dispatch(CategoryAction({}));
        dispatch(ProfileGetCategoryAction({}));

    }



    const handleDelete = async (id: any) => {
        // let confirmation = await handleShowSwalConfirmation("Do you want to delete?", true);
        let confirmation = await handleShowSwalConfirmation(intl.formatMessage({ id: 'delete_pop_up' }), true, true, intl.formatMessage({ id: 'are_you_sure' }));

        if (confirmation) {
            dispatch(StaffMemberDeleteAction({ delete_id: id }))
        }
    }

    const handleStaffMemberAdd = () => {
        dispatch(StaffMemberAddAction("RESET"))
    }

    return (
        <>
            <div className='col-lg-9 serviceManagement'>
                <div className='dashboard bg-white'>
                    <div className='dashboardTop d-sm-flex align-items-center'>
                        <h2><button type='button' className='btn mobileMenu p-1 d-lg-none' onClick={() => { sidebarOpen() }} ><span className="icon-menu-right"></span></button> <FormattedMessage id="staff_member" /></h2>
                        <div className='filterBTN d-none d-sm-flex'>
                            <div className='search'>
                                <span className="icon-search"></span>
                                <input type='search' className='form-control' placeholder={intl.formatMessage({ id: 'search' })} value={searched} onChange={handleSearchChange} />
                            </div>

                            <button type='button' className='btn btn-fill filterlist btn-sm' data-bs-toggle="modal" data-bs-target="#servicelistFilter" onClick={handleFilter}><i className="icon-filter"></i> <FormattedMessage id="filter" /></button>
                            {/* <Button type="button" text="+Add New Staff" className='btn btn-sm-outline' onClick={() => navigate("/service")} /> */}
                            <button type='button' className='btn btn-sm-outline' data-bs-toggle="modal" data-bs-target="#AddNewStaff" onClick={handleStaffMemberAdd}>+{<FormattedMessage id="add_new_staff" />}</button>
                            <button type='button' className='btn btn-sm-outline' onClick={handleReset}><FormattedMessage id="reset" /></button>
                        </div>

                        <div className='filterBTN d-sm-none'>
                            <div className='row gy-2'>
                                <div className='col-md-12'>
                                    <div className='search'>
                                        <span className="icon-search"></span>
                                        <input type='search' className='form-control  w-100' placeholder='Search' />
                                    </div>
                                </div>
                                <div className='col-6'>
                                    {/* <button type='button' className='btn btn-fill filterlist btn-sm w-100' data-bs-toggle="modal" data-bs-target="#servicelistFilter"><i className="icon-filter"></i> Filter</button> */}
                                </div>
                                <div className='col-6'>
                                    {/* <button type='button' className='btn btn-sm-outline  w-100'>+Add New Service</button>
                                     */}
                                    <button type='button' className='btn btn-sm-outline' data-bs-toggle="modal" data-bs-target="#AddNewStaff">+Add New Service</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='dashboarcard p-0'>
                        {

                            <MaterialReactTable
                                columns={columns}
                                data={data || []}
                                enableGlobalFilter={false}
                                enableHiding={false}
                                enableColumnFilters={false}
                                enableDensityToggle={false}
                                enableColumnActions={false}
                                enableFullScreenToggle={false}
                                positionToolbarAlertBanner="top"
                                initialState={{
                                    showColumnFilters: true,
                                    globalFilter: searchValue // Set the default search value here
                                }}
                                manualFiltering
                                manualPagination
                                manualSorting

                                muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data', } : undefined}
                                muiSearchTextFieldProps={{
                                    placeholder: 'Search from name',
                                }}
                                onColumnFiltersChange={setColumnFilters}
                                onGlobalFilterChange={(value: any) => handleSearchData(
                                    value,
                                    setIsError,
                                    setLoading,
                                    setIsRefetching,
                                    setSearchValue,
                                )
                                }
                                localization={MRT_Localization_AL}

                                onPaginationChange={setPagination}
                                onSortingChange={setSorting}
                                rowCount={rowCount}
                                state={{
                                    columnFilters,
                                    isLoading: loading,
                                    pagination,
                                    showAlertBanner: isError,
                                    showProgressBars: isRefetching,
                                    sorting,
                                }}
                            />
                        }
                    </div>
                </div>

            </div>
            <ServiceManagementFilter
                register={register}
                handleSubmit={handleSubmit}
                onSubmit={onSubmit}
                handleReset={handleReset}
                setValue={setValue}
                watch={watch}
                errors={errors}
                setDisableDate={setDisableDate}
                disableDate={disableDate}
            />
            <AddNewStaff />

        </>


    )
}

export default StaffMember

